import { render, staticRenderFns } from "./batch-search.vue?vue&type=template&id=32011b31"
import script from "./batch-search.vue?vue&type=script&lang=js"
export * from "./batch-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports